import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initializeGA, trackPageView, hasAnalyticsConsent } from '@/lib/analytics';

/**
 * Hook that tracks SPA page views in GA4.
 * Must be used inside a Router context.
 */
const usePageTracking = () => {
  const location = useLocation();

  // Initialize GA on mount (if consent exists)
  useEffect(() => {
    initializeGA();
  }, []);

  // Track page view on every route change
  useEffect(() => {
    // Small delay to let page title update
    const timeout = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 100);
    return () => clearTimeout(timeout);
  }, [location.pathname, location.search]);

  // Listen for consent changes (user accepts cookies mid-session)
  useEffect(() => {
    const handleStorage = (e: StorageEvent) => {
      if (e.key === 'cookie-consent' && e.newValue === 'all') {
        initializeGA();
        trackPageView(location.pathname + location.search);
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [location.pathname, location.search]);
};

export default usePageTracking;
